// initial state
const state = {
  details: {},
  isAdvisor: false,
  advisorUin: '',
  currentStudentUin: ''
}

// getters
const getters = {
    fullDetails: state => state
}

// actions
const actions = {
  
}

// mutations
const mutations = {
  setDetails (state, details) {
    state.details = details
  },
  setIsAdvisor (state, boolAdmin) {
    state.isAdvisor = boolAdmin
  },
  setAdvisorUin (state, uin) {
    state.advisorUin = uin
  },
  setCurrentStudentUin (state, uin) {
    state.currentStudentUin = uin
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}